import axios from "axios"
import { ResponseRequestGeneric } from "components/Types/GeneralTypes";
import configData from "config.json";
import { authHeader, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { AprobarSolicitudesHEDTO, InfGenerDirectivoSolicHEDTO } from "./TypesAprobacionHE";
import { hadleAxiosErrorResponse } from "helpers/handle-response";
import { UserData } from "components/Sidebar/Sidebar_Principal";

export const URL_CONTROLLER = `${configData.SERVER_URL}PresupuestoHorasExtras`

// export async function AprobarParcialmenteSolicitudHE(idSolicitud:number) {
//     return;
// }

export async function ObtenerInformacionGeneral() {
    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/DirectivoUnidad/SolicitudesHEPendientes`;
    var infoResponse: ResponseRequestGeneric<InfGenerDirectivoSolicHEDTO|string> = { status: -1 }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeader(),
            }
        )

        infoResponse.status = 200;
        infoResponse.dataResponse = respuesta.data;

    } catch (error) {
        infoResponse = hadleAxiosErrorResponse<InfGenerDirectivoSolicHEDTO|string>(error)
    }
    return infoResponse;
}

export async function FirmarEnviarSolicitudDirectivoU(solicitudes: AprobarSolicitudesHEDTO[]){
    const url = configData.SERVER_URL +  `SolicitudPagoHorasExtras/DirectivoUnidad/AprobacionSolicitudesDU`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<void> = { status: -1 }
    try {
        const respuesta = await axios.post(url,solicitudes,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )

        infoResponse = {
            status: respuesta.status
        }


    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = hadleAxiosErrorResponse<void>(error)
        }
    }
    return infoResponse;
}

export async function EnvioSolicitudRechazada(idSolicitud: number, observacion: any) {
    const url = configData.SERVER_URL +  `SolicitudPagoHorasExtras/DirectivoUnidad/RechazoSolicitudesDU/${idSolicitud}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<void> = { status: -1 }
    try {
        const respuesta = await axios.post(url, observacion,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )

        infoResponse = {
            status: respuesta.status,
            dataResponse: respuesta.data
        }


    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = hadleAxiosErrorResponse<void>(error)
        }
    }
    return infoResponse;
}

export async function obtenerValorTotal(idEstructura: number) {
    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/DirectivoUnidad/ValorAprobadoDirectivo/${idEstructura}`;
    var infoResponse: ResponseRequestGeneric<number> = { status: -1 }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeader(),
            }
        )

        infoResponse.status = 200;
        infoResponse.dataResponse = respuesta.data;

    } catch (error) {
        infoResponse = hadleAxiosErrorResponse<number>(error)
    }
    return infoResponse;
}

// export async function VistaPreviaSolicitudHEFirmada(idSolicitud:number){
//     const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/VistaPreviaSolicitudHorasExtras/${idSolicitud}`;
//     const infoUsuario: UserData = authenticationService.currentUserValue;

//     var infoResponse: ResponseRequestGeneric<string> = { status: -1 }
//     try {
//         const respuesta = await axios.get(url,
//             {
//                 headers: authHeaderWithUserData(infoUsuario),
//                 responseType: "blob"
//             }
//         )

//         let urFormulario = window.URL.createObjectURL(respuesta.data);
//         infoResponse = { status: respuesta.status, dataResponse: urFormulario }

//     } catch (error) {
//         if (axios.isAxiosError(error) && error.response) {
//             var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();
//             infoResponse = { status: error.response.status, errorMessage: mensaje }
//         }
//     }
//     return infoResponse;
// }